<template lang="pug">
  ul.pf-step-navigation
    li(v-for="step in steps")
      a(:class="stepStatus(step)")
        span {{ step }}
        font-awesome-icon(icon="check")
</template>

<script>
export default {
  name: 'StepNavigation',
  props: {
    activeStep: Number,
    steps: Array,
  },
  methods: {
    stepStatus(stepNumber) {
      if (stepNumber === this.activeStep) {
        return 'active';
      }
      if (stepNumber < this.activeStep) {
        return 'completed';
      }
      return '';
    },
  },
};
</script>
